import React, { useContext } from 'react';

const pdfContext = React.createContext();
const pdfUpdateContext = React.createContext();

export function usePDF() {
    return useContext(pdfContext);
}
export function usePDFUpdate() {
    return useContext(pdfUpdateContext);
}


export function PDFProvider({ children }) {
    
    const [pdfID, setpdfID] = React.useState();
    
    function setPDFIndex(_index) {
        setpdfID(_index);
    } 
    
    return (
        <pdfContext.Provider value={pdfID}>
            <pdfUpdateContext.Provider value={setPDFIndex}>
                {children}
            </pdfUpdateContext.Provider>
        </pdfContext.Provider>          
    )
}
